// Facility rooms — thin route wrapper. All behavior lives in
// FacilityRoomsClient (1:1 port of legacy room-management.tsx +
// rooms-client.tsx — see that file's header for endpoint map).

import { createFileRoute } from "@tanstack/react-router";

import { AccountSecurityBanner } from "@/components/account/account-security-banner";
import { FacilityRoomsClient } from "@/components/account/facility/facility-rooms-client";

export const Route = createFileRoute("/_authenticated/account/facility/$facilityId/rooms")({
  component: FacilityRoomsPage,
});

function FacilityRoomsPage() {
  const { facilityId } = Route.useParams();
  return (
    <div className="space-y-5">
      <FacilityRoomsClient facilityId={facilityId} />
      <AccountSecurityBanner />
    </div>
  );
}
